import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

import View from './AdvWorkflowStepView';
import { iterator, currentClientId, isFirstStep, isPopulatedSelector, isGoingBackwardSelector, isGoingForwardSelector } from '../AdvWorkflow/AdvWorkflowSelector';
import { skip } from '../AdvWorkflow/AdvWorkflowActions';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  iterator: iterator(state, ownProps),
  isFirstStep: isFirstStep(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  isGoingBackward: isGoingBackwardSelector(state, ownProps),
  isGoingForward: isGoingForwardSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  skip: (isGoingForward, isGoingBackward, workflowId, clientId) => {
    dispatch(skip(isGoingForward, isGoingBackward, workflowId, clientId));
  },
});

const AdvWorkflowStepContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);

AdvWorkflowStepContainer.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired),
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default AdvWorkflowStepContainer;
